import React from 'react';

import { useParams } from 'react-router-dom';

import { Link, Typography } from '@mui/material';

export default function PoliciesTab() {
  const { id_offer: offerId } = useParams<{ id_offer: string }>();
  const roomPoliciesPath = `/edit-offers/${offerId}/room-policies`;

  return (
    <Typography variant="body1" color="text.secondary">
      Room Policies coming soon.{' '}
      <Link href={roomPoliciesPath} target="_blank" rel="noopener">
        Open current Room Policies page
      </Link>
    </Typography>
  );
}
